import * as React from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import VenueModalButton from "../VenueModal/VenueModal.tsx";
import Stack from "@mui/material/Stack";
import { ChildVenue, SortOption } from "../../types/dataTypes.ts";

type FilmTabFiltersProps = {
  sortOption: SortOption;
  handleSortChange: (event: SelectChangeEvent) => void;
  venuesNearLocation: ChildVenue[];
  selectedVenues: string[];
  onVenueToggle: (clickedVenue: string) => void;
  onDialogClose: () => void;
  setIsVenueModalOpen: (isOpen: boolean) => void;
  toggleSelectAllVenues: (selectAll: boolean) => void;
  selectAllVenuesLabel: string;
  venueDistanceLabel: string;
};

export const FilmTabFilters: React.FC<FilmTabFiltersProps> = ({
  sortOption,
  handleSortChange,
  venuesNearLocation,
  selectedVenues,
  onVenueToggle,
  onDialogClose,
  setIsVenueModalOpen,
  toggleSelectAllVenues,
  selectAllVenuesLabel,
  venueDistanceLabel,
}) => {
  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      spacing={4}
      justifyContent="center"
      alignItems="center"
      sx={{ width: "100%", mt: { md: 2, xs: 0 }, maxWidth: "100%" }}
    >
      <VenueModalButton
        venues={venuesNearLocation}
        selectedVenues={selectedVenues}
        onVenueToggle={onVenueToggle}
        onDialogClose={onDialogClose}
        setIsVenueModalOpen={setIsVenueModalOpen}
        toggleSelectAllVenues={toggleSelectAllVenues}
        selectAllVenuesLabel={selectAllVenuesLabel}
        venueDistanceLabel={venueDistanceLabel}
      />
      <FormControl sx={{ width: { md: "50%", xs: "90%" } }}>
        <InputLabel id="sort-by-label">Sort Films by</InputLabel>
        <Select
          labelId="sort-by-label"
          value={sortOption}
          label="Sort Films By"
          onChange={handleSortChange}
        >
          <MenuItem value="alphabetical">{`Film Title (A-Z)`}</MenuItem>
          <MenuItem value="popular">Most popular</MenuItem>
        </Select>
      </FormControl>
    </Stack>
  );
};
